<div class="forgot-password-form-wrapper">
  <img src="./assets/images/logo.svg" class="logo" alt="logo" />
  <xos-forgot-password-form></xos-forgot-password-form>
</div>
